import { Alert, Button, Dropdown, Space, Spin, Tag } from "antd";
import { useTranslation } from "react-i18next";
import type { ReportFilterState } from "../../hooks/useReportFilters";
import { useReportExport } from "../../hooks/useReports";

interface Props {
	kind: string;
	filters: ReportFilterState;
}

/**
 * Split eksport tugmasi: asosiy qism — XLSX, menyuda — CSV. Tayyorlanish
 * holati tugma yonida pill, tayyor bo'lsa «Yuklab olish (N qator)».
 *
 * ⚠️⚠️ **BITTA `useReportExport` instansiyasi** — ikki format bitta
 * `jobId` holatini bo'lishadi; ikki instansiya bo'lsa «Yuklab olish»
 * tugmasi ikkinchi formatda ko'rinmay qolardi (eski `ExportButton`
 * saboqi).
 *
 * ⚠️ **Yuklab olish `apiClient` orqali blob** (`useReportExport`),
 * `window.open()` EMAS — access token faqat JS xotirasida.
 *
 * ⚠️ `Dropdown.Button` EMAS — antd 6.6 da `@deprecated` («use
 * Space.Compact + Dropdown + Button instead», `dropdown-button.d.ts`).
 */
export function ExportSplitButton({ kind, filters }: Props) {
	const { t } = useTranslation("reports");
	const eksport = useReportExport(kind);
	const job = eksport.job;
	const kutilmoqda = job?.status === "pending" || job?.status === "processing";
	const band = eksport.request.isPending || kutilmoqda;

	return (
		<Space wrap size={8} className="skud-no-print" data-testid="export-split">
			<Space.Compact>
				<Button
					type="primary"
					data-testid="export-xlsx"
					disabled={band}
					loading={eksport.request.isPending && eksport.request.variables?.format === "xlsx"}
					onClick={() => eksport.request.mutate({ filters, format: "xlsx" })}
				>
					{t("export.xlsxButton")}
				</Button>
				<Dropdown
					trigger={["click"]}
					disabled={band}
					menu={{
						items: [{ key: "csv", label: t("export.csvMenu") }],
						onClick: () => eksport.request.mutate({ filters, format: "csv" }),
					}}
				>
					<Button
						type="primary"
						data-testid="export-more"
						aria-label={t("export.moreFormats")}
						disabled={band}
					>
						▾
					</Button>
				</Dropdown>
			</Space.Compact>

			{kutilmoqda ? (
				<Tag data-testid="export-pending" className="!m-0 inline-flex items-center gap-1.5">
					<Spin size="small" />
					{t("export.preparing")}
				</Tag>
			) : null}

			{job?.status === "done" ? (
				<Button data-testid="export-download" onClick={() => eksport.download()}>
					{t("export.downloadButton", { count: job.rowCount ?? 0 })}
				</Button>
			) : null}

			{job?.status === "failed" ? (
				// ⚠️ Sabab SERVERDAN (`error`) — `messages` dagi matn.
				<Alert type="error" showIcon message={job.error ?? t("export.failed")} />
			) : null}
		</Space>
	);
}
